import { FieldValues, FieldPath } from "react-hook-form"
import { InputField } from "../InputField"
import type { PhoneNumberFieldProps } from "./PhoneNumberField.types"

/**
 * PhoneNumberField wraps InputField with the correct HTML attributes
 * (type="tel", autoComplete="tel") so phone numbers correctly display
 * and auto-populate via browser autofill.
 */
export function PhoneNumberField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  control,
  label,
  required,
  help,
  placeholder = "Phone number",
  disabled,
  size,
  variant,
  allowClear,
  maxLength,
}: PhoneNumberFieldProps<TFieldValues, TName>) {
  return (
    <InputField
      name={name}
      control={control}
      label={label}
      required={required}
      help={help}
      placeholder={placeholder}
      disabled={disabled}
      size={size}
      variant={variant}
      allowClear={allowClear}
      maxLength={maxLength}
      type="tel"
      autoComplete="tel"
    />
  )
}
